<script setup lang="ts">
export interface AccessCodeRedeemProps {
  disabled?: boolean;
  inputPlaceholder?: string;
  outline?: boolean;
  rootClass?: string;
}

const emit = defineEmits(["submit"]);
const props = withDefaults(defineProps<AccessCodeRedeemProps>(), {});
const redeemCode = ref("");
const onSubmit = () => emit("submit", redeemCode.value);
</script>

<template>
  <div :class="props.rootClass">
    <slot name="label" />

    <div>
      <BaseInput
        v-model="redeemCode"
        :placeholder="props.inputPlaceholder"
        :outline="props.outline"
        :disabled="props.disabled"
        name="access-code"
        required
        @keyup.enter="onSubmit()"
      >
        <template #suffix>
          <slot name="input-suffix" :disabled="props.disabled || !redeemCode" :on-submit="onSubmit" />
        </template>
      </BaseInput>
      <slot name="button" :disabled="props.disabled || !redeemCode" :on-submit="onSubmit" />
    </div>
  </div>
</template>

<style lang="scss">
.accessCodeRedeem {
  border: 1px solid var(--base-card-bgColor);
  border-radius: var(--base-border-radius);
}
</style>
